import { useBackgroundQuery, type QueryRef } from '@apollo/client/react';
import { useMemo } from 'react';

import { QueryOrderEnum, BackupMembersOrderByEnum } from 'src/graphql/schema';
import { BackupMembersDocument } from 'src/graphql/actions/backupMembers/backupMembers.query';
import { createRequiredContext } from 'src/context/createRequiredContext';
import { useBackup } from 'src/context/backup';

import type { IBackupMembersQuery } from 'src/graphql/actions/backupMembers/backupMembers.query';

const [useMembersManagement, MembersManagementProvider] = createRequiredContext<{
  queryBackupMembersRef: QueryRef<IBackupMembersQuery>;
  backupId: string;
}>();

const MembersManagementContextProvider = ({ children }: React.PropsWithChildren) => {
  const {
    backup: { id: backupId },
  } = useBackup();

  const [queryRef] = useBackgroundQuery(BackupMembersDocument, {
    variables: {
      backupId,
      page: 1,
      perPage: 100,
      orderBy: BackupMembersOrderByEnum.Role,
      order: QueryOrderEnum.Asc,
    },
  });

  const queryBackupMembersRef = useMemo(() => queryRef, [queryRef]);

  const values = {
    backupId,
    queryBackupMembersRef,
  };

  return <MembersManagementProvider value={values}>{children}</MembersManagementProvider>;
};

export { MembersManagementContextProvider, useMembersManagement };
